import { render, staticRenderFns } from "./BaseButtonRound.vue?vue&type=template&id=5aabe33e&scoped=true&"
import script from "./BaseButtonRound.vue?vue&type=script&lang=js&"
export * from "./BaseButtonRound.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonRound.vue?vue&type=style&index=0&id=5aabe33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aabe33e",
  null
  
)

export default component.exports